import { useEffect } from 'react';

import { history } from '@/components/root';

import { ROUTE_WORKFLOW_DASHBOARD } from '@/constant/routes';
import { ErrorPage } from '@/components/errorPage/errorPage';

type Props = {
  description?: string;
  label?: string;
};

export const PageNotFound = ({
  description = 'Sorry, looks like this page do not exist!',
  label = 'take me home'
}: Props) => {
  const goTo = () => history.push(ROUTE_WORKFLOW_DASHBOARD);

  useEffect(() => {
    document.title = 'Oops! Page not found - Trace';
  }, []);

  return (
    <ErrorPage
      onHomeClick={goTo}
      description={description}
      buttonLabel={label}
    />
  );
};
